import { useEffect } from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import { withUserLocationContext } from '@honda-canada/user-location';
import PropTypes from 'prop-types';

const UserLocationRequester = ({
  isFetchingUserLocation,
  shouldRequestLocationOnLoad,
  provinceCode,
  requestUserEnterLocation,
}) => {
  useEffect(() => {
    if (!isFetchingUserLocation && shouldRequestLocationOnLoad && !provinceCode) {
      if (requestUserEnterLocation) {
        requestUserEnterLocation();
      }
    }
  }, [shouldRequestLocationOnLoad, provinceCode]);

  return null;
};

UserLocationRequester.propTypes = {
  isFetchingUserLocation: PropTypes.bool,
  shouldRequestLocationOnLoad: PropTypes.bool,
  provinceCode: PropTypes.string,
  requestUserEnterLocation: PropTypes.func,
};

export default withUserLocationContext(UserLocationRequester);
